/**
 * Return text content of HTML string
 * @param raw HTML string
 * @returns text content of the passed string
 * @see https://stackoverflow.com/a/34064434/1654241
 */

export function htmlDecode(raw: string) {
  const doc = new DOMParser().parseFromString(raw, 'text/html');
  return doc.documentElement.textContent ?? '';
}
